import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from "react-router-dom";

import Grid from '@mui/material/Grid2';

import { 
  User, 
} from "@models";
import { 
  Campaign, 
  Character,
  CharacterOptions
} from "@dndModels";

import API from "@dndUtilities/system_api";

import LoadingBox from "@components/input/LoadingBox";
import CenteredMenu from "@components/input/menus/CenteredMenu";
import ButtonBox from "@components/input/buttons/ButtonBox";

import ObjectDetails from "@dndComponents/ObjectDetails";
import CharacterOptionsInput from "@dndComponents/character/misc/CharacterOptionsInput";
import CommonUtilities from "@utilities/common_utilities";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

export default function CampaignJoin() {
  const { id, invite } = useParams();
  const [loading, setLoading] = useState(false);
  // const [logging_in, setLoggingIn] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [navigateTo, setNavigateTo] = useState<string | null>(null);
  const [obj, setObj] = useState<Campaign>(new Campaign());
  const [players, setPlayers] = useState<User[]>([]);
  const [characters, setCharacters] = useState<Character[]>([]);
  const [mode, setMode] = useState("Home");
  const [do_submit, setDoSubmit] = useState(false);
  
  // eslint-disable-next-line
  useEffect(() => {
    if(!fetched) {
      setFetched(true);
      if (api.user === null) {
        const userObjStr = localStorage.getItem("loginUser");
        if (!userObjStr) {
          setNavigateTo("/labs");
        } else {
          // setLoggingIn(true);
          check_login();
        }
      } else {
        load();
      }
    }
  });
    
  useEffect(() => {
    if (do_submit) {
      setDoSubmit(false);
      submit();
    }
    // eslint-disable-next-line
  }, [do_submit]);

  const check_login = () => {
    setTimeout(() => {
      if (api.user === null) {
        check_login();
      } else {
        // setLoggingIn(false);
        load();
      }
    }, 1000);
  }

  const submit = () => {
    setProcessing(true);
    const last_updated = common_util.get_time_number();
    obj.last_updated = last_updated;
    if (obj._id && obj._id !== "") {
      api.updateObject("campaign", obj).then(res => {
        setProcessing(false);
      });
    } else {
      obj.owner_id = api.user ? api.user._id : "No Login";
      api.createObject("campaign", obj).then(res => {
        setProcessing(false);
      });
    }
  }

  const load_object = (id: string) => {
    setLoading(true);
    api.getObjects({ data_type: "campaign", filter: { "_id*ObjectIDs": [id] } }).then(res => {
      if (res.length === 1 && res[0] instanceof Campaign) {
        setObj(res[0]);
        if (invite !== undefined && (obj.reusable_invite === invite || obj.invites.includes(invite))) {
          load_players(obj);
        } else {
          setLoading(false);
        }
      }
    });
  }

  const load_players = (use_obj: Campaign) => {
    if (use_obj.player_ids.length > 0) {
      const filter = {
        "_id*ObjectIDs": [...use_obj.player_ids]
      };
      api.getObjectsOld("user", filter).then(res => {
        setPlayers(res as User[]);
        load_characters(use_obj);
      });
    } else {
      load_characters(use_obj);
    }
  }

  const load_characters = (use_obj: Campaign) => {
    const filter: any = {};
    
    filter.campaign_id = use_obj._id;
    api.getObjectsOld("character", filter).then(res => {
      setCharacters(res as Character[]);
      setLoading(false);
    });
  }

  const load = () => {
    // api.getSetOfObjects({ data_types: ["source_book","race","subrace","game_class","subclass","gift"]}).then(res => {
      
    //   setSourceBooks(res.source_book as SourceBook[]);
    //   setRaces(res.race as Race[]);
    //   setSubraces(res.subrace as Subrace[]);
    //   setClasses(res.game_class as GameClass[]);
    //   setSubclasses(res.subclass as Subclass[]);
    //   setGifts(res.gift as Gift[]);
    if (id !== undefined && invite !== undefined && obj._id !== id) {
      load_object(id);
    } else {
      setLoading(false);
    }
    // });
  }

  const render_tab = () => {
    let return_me = <Grid>Coming Soon</Grid>;
    if (mode === "Options") {
      return_me = (
        <CharacterOptionsInput 
          obj={obj}
          disabled={true}
          onChange={(options: CharacterOptions) => {
            
          }}
        />
      ); 
    } else if (mode === "Players") {
      return_me = (
        <Grid container spacing={0} direction="row">
          { players.map((player, key) => {
            return (
              <Grid
                key={key}
                size={{
                  xs: 4
                }}>
                { player.username }
              </Grid>
            );
          })}
        </Grid>
      ); 
    } else if (mode === "Characters") {
      return_me = (
        <Grid container spacing={0} direction="row">
          { characters.map((char, key) => {
            return (
              <Grid
                key={key}
                size={{
                  xs: 4
                }}>
                { char.name }
              </Grid>
            );
          })}
        </Grid>
      ); 
    }
    return return_me;
  }
  
  if (!fetched || loading) {
    const height = window.innerHeight - 64;
    return (<LoadingBox size={height * 0.5} height={height} width={window.innerWidth} />);
  } else if (navigateTo !== null) {
    return <Navigate to={navigateTo} />;
  } else if (!api.online) {
    return (
      <>Joining only work while online.  Try reconnecting.</>
    );
  } else if (obj === null) {
    return <span>Something is wrong with the link you clicked</span>;
  } else if (api.user && obj.player_ids.includes(api.user._id)) {
    return <span>You're already in this campaign.</span>;
  } else if (api.user && obj.owner_id === api.user._id) {
    return <span>You own this campaign.</span>;
  } else { 
    const formHeight = window.innerHeight - (window.innerWidth > 600 ? 228 : 228);
    const tabs = ["Characters","Players","Options"];
    return (
      <Grid container spacing={0} direction="column">
        <Grid>
          You've been invited to join a campaign.  
        </Grid>
        { api.user ? 
          <Grid>
            <ButtonBox 
              name="Accept Invitation"
              disabled={processing}
              onClick={() => {
                if (api.user) {
                  const new_obj = obj;
                  if (invite && new_obj.invites.includes(invite)) {
                    new_obj.invites = new_obj.invites.filter(o => o !== invite);
                  }
                  new_obj.player_ids.push(api.user._id);
                  api.updateObject("campaign", new_obj).then(res => {
                    setNavigateTo(`/dandd/campaign/details/${new_obj._id}`);
                  });
                }
              }}
            />
          </Grid>
          :
          <Grid>
            You need to log in first to be able to join.
          </Grid>
        }
        <Grid>
          <ObjectDetails 
            obj={obj}
          />
        </Grid>
        <Grid>
          <CenteredMenu
            options={tabs}
            selected={mode}
            onSelect={setMode}
          />
        </Grid>
        <Grid
          style={{ 
            height: `${formHeight}px`, 
            overflowY: "scroll", 
            overflowX: "hidden" 
          }}>
            { render_tab() }
        </Grid>
      </Grid>
    );
  }
}
